import { makeStyles, Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    root: {
        padding: "2rem",
        marginBottom: "1.25rem",
        "& >p": {
            padding: 0,
            margin: 0,
            fontSize: "1rem"
        }
    },
    title: {
        padding: 0,
        margin: 0,
        fontSize: "1.2rem !important",
        color: "#212121",
        fontWeight: 600
    },
    transactions: {
        backgroundColor: "rgb(79, 60, 201, 0.1)",
        color: "black",
        borderRadius: "30px",
        width: "15rem",
        padding: "0.25rem",
        textAlign: "center",
        margin: "1.25rem 0",
        "& >p": {
            color: "#4F3CC9",
            opacity: 1,
            padding: 0,
            margin: 0
        }
    },
    infoText: {
        fontWeight: 600
    }
})

export function PaymentCard() {
    const { root, title, transactions, infoText } = useStyles();
    const { t } = useTranslation();
    return <Paper className={root}>
        <p className={title}>{t('openBanking.paymentCard.title')}</p>
        <div className={transactions}>
            <p>{t('openBanking.paymentCard.transaction', { percentage: 0 })}</p>
        </div>
        <p className={infoText}>{t('openBanking.paymentCard.info1')}</p>
        <p>{t('openBanking.paymentCard.info2')}</p>
    </Paper>
}